const imgDns = 'https://shopyf.oss-cn-shenzhen.aliyuncs.com/';
const mapKey = '7QQBZ-V2JRO-ORRWF-SFQ6S-WZBFT-CNFKN';
export {
    imgDns,
    mapKey
};


// WEBPACK FOOTER //
// ./src/digitalHuman/tool/const.js